import TEMPLATE_URL from "emun.auth/users/location-picker.htm";
import controller from "emun.auth/users/location-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "lg",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Select Locations(s)...",
	subTitle = "",
	view = "table",
	single = false,
	viewSelections = false,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	selected = {},
	criteria = {},
	onToggle = NOOP,
	onLocationSelected = NOOP,
	onLocationDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		console: console.debug(templateUrl, {
			placement,
			size,
			backdrop,
			title,
			view
		}),
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onLocationSelected,
				onLocationDeselected,
				onToggle,
				criteria,
				view,
				viewSelections,
				okButtonText,
				closeButtonText,
				single,
				selected
			})
		}
	}).result;
